import { SVGProps, Ref, forwardRef } from 'react';

export const FolderOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.696 6.804c.342.342.64.89.821 1.838a15 15 0 0 0-2.211-.142H5.694c-.916 0-1.71.054-2.391.171.037-2.294.466-3.332 1.001-3.867.56-.56 1.67-1.004 4.196-1.004h1.781l.8 2H15.5c2.525 0 3.636.444 4.196 1.004M1.5 9.278V9c0-5.25 1.75-7 7-7h3l.8 2h3.2c4.61 0 6.52 1.349 6.919 5.231 1.63.908 1.923 2.741 1.23 5.933C22.56 20.163 20.692 22 15.6 22H8.4c-5.093 0-6.961-1.837-8.048-6.836-.682-3.138-.41-4.962 1.148-5.886m20.39 5.504c-.522 2.397-1.157 3.628-1.948 4.32-.759.663-1.972 1.098-4.342 1.098H8.4c-2.37 0-3.583-.435-4.342-1.098-.79-.692-1.426-1.923-1.947-4.32-.541-2.488-.265-3.37-.001-3.698.26-.326 1.05-.784 3.584-.784h12.612c2.533 0 3.323.458 3.584.784.264.329.54 1.21 0 3.698"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
FolderOutlinedSize24Glyph.displayName = 'FolderOutlinedSize24Glyph';
